import { Component, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { EkuroService, IClinicas } from './ekuro.service';
import { CommonModule, DatePipe } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LoadingModalComponent } from '../../../loading-modal/loading-modal.component';
import { AlertComponent } from '../../../alert/alert.component';

@Component({
  selector: 'app-ekuro-integracao',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    ReactiveFormsModule,
    LoadingModalComponent,
    AlertComponent,
  ],
  templateUrl: './ekuro-integracao.component.html',
  styleUrls: ['./ekuro-integracao.component.scss'],
  providers: [EkuroService, DatePipe],
})
export class EkuroIntegracaoComponent implements OnInit {
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  public visibilidadeModalCadastroClinica: boolean = false;
  public visibilidadeModalConfiguracaoClinica: boolean = false;

  public mostrarInformacoes: boolean = false;

  public listaDeClinicas!: Array<IClinicas>;
  public clinicaSelecionada!: IClinicas;

  public formularioInsercaoClinica!: FormGroup;
  public formularioEdicaoClinica!: FormGroup;
  constructor(
    private ekuroService: EkuroService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.formularioInsercaoClinica = this.fb.group({
      nomeClinica: ['', [Validators.required]],
      clinicaId: ['', [Validators.required]],
      appAccessToken: ['', [Validators.required]],
      mensagemConfirmacaoConsulta: ['', [Validators.required]],
      mensagemLembreteConsulta: ['', [Validators.required]],
      somaDia: ['', [Validators.required]],
      horario: ['', [Validators.required]],
      queueId: ['', [Validators.required]],
      apiKey: ['', [Validators.required]],
      host: ['', [Validators.required]],
    });
  }

  async ngOnInit() {
    await this.listarClinicasCadastradas();
  }

  public listarClinicasCadastradas(): void {
    this.ekuroService
      .listarTodasAsClinicas()
      .subscribe((response: Array<IClinicas>) => {
        this.listaDeClinicas = response;
      });
  }

  public handleAbrirModalCadastroClinica(): void {
    this.visibilidadeModalCadastroClinica =
      !this.visibilidadeModalCadastroClinica;
  }

  public closeModalCadastroClinica(): void {
    this.visibilidadeModalCadastroClinica = false;
    this.handleExecutarAoFecharModalCadastroClinica();
  }

  public handleAbrirModalConfiguracaoClinica(clinicaObject: IClinicas): void {
    this.clinicaSelecionada = clinicaObject;
    this.formularioEdicaoClinica = this.fb.group({
      id: [this.clinicaSelecionada.id, [Validators.required]],
      nomeClinica: [this.clinicaSelecionada.nomeClinica, [Validators.required]],
      clinicaId: [this.clinicaSelecionada.clinicaId, [Validators.required]],
      appAccessToken: [
        this.clinicaSelecionada.appAccessToken,
        [Validators.required],
      ],
      mensagemConfirmacaoConsulta: [
        this.clinicaSelecionada.mensagemConfirmacaoConsulta,
        [Validators.required],
      ],
      mensagemLembreteConsulta: [
        this.clinicaSelecionada.mensagemLembreteConsulta,
        [Validators.required],
      ],
      somaDia: [this.clinicaSelecionada.somaDia, [Validators.required]],
      horario: [this.clinicaSelecionada.horario, [Validators.required]],
      queueId: [this.clinicaSelecionada.queueId, [Validators.required]],
      apiKey: [this.clinicaSelecionada.apiKey, [Validators.required]],
      host: [this.clinicaSelecionada.host, [Validators.required]],
    });

    this.visibilidadeModalConfiguracaoClinica =
      !this.visibilidadeModalConfiguracaoClinica;
  }

  public closeModalConfiguracaoClinica(): void {
    this.visibilidadeModalConfiguracaoClinica = false;
    this.handleExecutarAoFecharModalConfiguracaoClinica();
  }

  public handleExecutarAoFecharModalCadastroClinica(): void {
    this.formularioInsercaoClinica.reset();
  }

  public handleExecutarAoFecharModalConfiguracaoClinica(): void {}

  public handleMostrarInformacoes(): void {
    this.mostrarInformacoes = !this.mostrarInformacoes;
  }

  private formatHorario(value: string | Date | null): string | null {
    if (!value) return null;
    if (typeof value === 'string') return value;
    return this.datePipe.transform(value, 'HH:mm');
  }

  public handleEnviarCadastroClinica(): void {
    this.visibilidadeModalCadastroClinica = false;
    this.loadingComponent.activeLoading();
    const payload = {
      ...this.formularioInsercaoClinica.value,
      somaDia: this.formularioInsercaoClinica.value.somaDia?.toString(),
      horario: this.formatHorario(this.formularioInsercaoClinica.value.horario),
    };

    this.ekuroService
      .cadastrarClinica(payload)
      .subscribe(
        (response: any) => {
          this.loadingComponent.inactiveLoading();
          this.alertComponent.showAlert(`${response.status}`, 'success');
          this.closeModalCadastroClinica();
          this.listarClinicasCadastradas();
        },
        (error: any) => {
          this.loadingComponent.inactiveLoading();
          this.visibilidadeModalCadastroClinica = true;
          this.alertComponent.showAlert(
            'Erro ao tentar inserir clinica',
            'error'
          );
        }
      );
  }

  public handleEnviarAtualizacaoClinica(): void {
    this.loadingComponent.activeLoading();
    const payload = {
      ...this.formularioEdicaoClinica.value,
      somaDia: this.formularioEdicaoClinica.value.somaDia?.toString(),
      horario: this.formatHorario(this.formularioEdicaoClinica.value.horario),
    };

    this.ekuroService
      .atualizarClinica(payload)
      .subscribe(
        (response: any) => {
          this.alertComponent.showAlert(`${response.status}`, 'success');
          this.loadingComponent.inactiveLoading();
          this.closeModalConfiguracaoClinica();
          this.listarClinicasCadastradas();
        },
        (error: any) => {
          this.alertComponent.showAlert(`${error.error.status}`, 'error');
          this.loadingComponent.inactiveLoading();
        }
      );
  }

  public deletarClinica(idClinica: number): void {
    this.visibilidadeModalConfiguracaoClinica = false;
    this.loadingComponent.activeLoading();
    this.ekuroService.deletarClinica(idClinica).subscribe(
      (response: any) => {
        this.listarClinicasCadastradas();
        this.alertComponent.showAlert(`${response.status}`, 'success');
        this.loadingComponent.inactiveLoading();
      },
      (error: any) => {
        this.loadingComponent.inactiveLoading();
        this.alertComponent.showAlert(`${error.error.status}`, 'error');
      }
    );
  }
}
